<template>
  <div class="item">
    <div class="year">{{ year }}</div>
    <div class="label">{{ label }}</div>
    <div class="description">{{ description }}</div>
  </div>
</template>

<script>
export default {
  props: {
    year: String,
    label: String,
    description: String
  }
};
</script>

<style lang="scss" scoped>
.item {
  text-align: center;

  .year {
    color: #1c2e53;
    font-size: 24px;
    letter-spacing: 2.4px;
    font-weight: bold;
  }

  .label {
    color: white;
    font-weight: bold;
    font-size: 20px;
    padding: 10px;
    background-color: #63abcd;
    border-radius: 8px;
    margin: 8px auto;
    display: inline-block;
  }

  .description {
    color: #565656;
    font-size: 14px;
    letter-spacing: 1.4px;
    font-weight: bold;
    padding: 0 6px;
  }
}

@media (max-width: 1023px) {
  .year {
    font-size: 17px !important;
  }

  .label {
    font-size: 14px !important;
    min-width: 100px !important;
    padding: 2px 7px !important;
  }

  .description {
    font-size: 14px !important;
    margin: auto 40px;
  }
}
</style>
